import * as mock from "../mocks/accountDevices.mock.js";

export function listAccountDevices(accountId) {
  return mock.listAccountDevices(accountId);
}

export function listUnassignedDevices() {
  return mock.listUnassignedDevices();
}

export function createAccountDevice(accountId, payload) {
  return mock.createAccountDevice(accountId, payload);
}

export function updateAccountDevice(accountId, id, payload) {
  return mock.updateAccountDevice(accountId, id, payload);
}

export function deleteAccountDevice(accountId, id) {
  return mock.deleteAccountDevice(accountId, id);
}

export function deassignAccountDevice(accountId, id) {
  return mock.deassignAccountDevice(accountId, id);
}

export function assignDeviceToAccount(deviceId, accountId) {
  return mock.assignDeviceToAccount(deviceId, accountId);
}

export function listAllDevices() {
  return mock.listAllDevices();
}

export function updateDeviceById(id, payload) {
  return mock.updateDeviceById(id, payload);
}

export function deleteDeviceById(id) {
  return mock.deleteDeviceById(id);
}

export function deassignDeviceById(id) {
  return mock.deassignDeviceById(id);
}

export function assignDeviceById(deviceId, accountId) {
  return mock.assignDeviceToAccount(deviceId, accountId);
}
